<template>
  <div>
    <div>
      <router-link to="/">Home </router-link>
      <label class="labelBar"> / </label>
      <router-link to="/chamadoManutencao">
        Manutenção/Chamado Manutencao
      </router-link>
      <label class="labelBar"> / </label>
      <label> Criar</label>
    </div>
    <v-container fluid>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-row>
          <v-col cols="12" sm="4">
            <v-autocomplete
              v-model="unidadeAdmSelected"
              :items="filteredUnidAdm"
              label="Unidade Administrativa *"
              item-text="descricao"
              item-value="id"
              persistent-hint
              return-object
              :readonly="readOnly"
              :rules="[(v) => !!v || 'A Unidade Administrativa é obrigatória']"
              required
            >
            </v-autocomplete>
          </v-col>
          <v-col cols="12" sm="4">
            <v-autocomplete
              v-model="equipamentoSelected"
              :items="equipamentos"
              label="Equipamento *"
              item-text="centroCusto"
              item-value="id"
              persistent-hint
              return-object
              :readonly="readOnly"
              :rules="[(v) => !!v || 'O Equipamento é obrigatório']"
              required
            >
            </v-autocomplete>
          </v-col>
          <v-col cols="12" sm="4">
            <v-subheader><strong>Prioridade</strong></v-subheader>
            <hr />
            <div class="flex-center">
              <v-radio-group v-model="tipo" row>
                <v-radio label="Normal" value="N"></v-radio>
                <v-radio label="Emergencial" value="E"></v-radio>
              </v-radio-group>
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12">
            <v-textarea
              label="Relato"
              v-model="descricao"
              v-uppercase
              clear-icon="mdi-close-circle"
            ></v-textarea>
          </v-col>
        </v-row>
      </v-form>
      <v-row align="center-left">
        <v-col class="text-right">
          <v-btn to="/chamadoManutencao" color="error" class="mr-4">
            Voltar
          </v-btn>
          <v-btn @click="enviar" color="success" class="mr-4"> Salvar </v-btn>
        </v-col>
      </v-row>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-container>
  </div>
</template>

<script>
import { enviarChamadoManutencaoAsync } from "../../../services/chamadoManutencaoService";
import { mapState } from "vuex";

export default {
  name: "criarChamadoManutencao",
  data: () => ({
    tipo: "N",
    overlay: false,
    valid: true,
    descricao: null,
    equipamentoSelected: null,
    unidadeAdmSelected: null,
  }),
  computed: {
    ...mapState("equipamento", ["equipamentos"]),
    ...mapState("local", ["locais"]),
    filteredUnidAdm() {
      return this.locais.filter((lc) => {
        return (
          (lc.idTipoLocais === 2 || lc.idTipoLocais === 3) && lc.ativo === true
        );
      });
    },
  },
  methods: {
    async enviar() {
      if (this.$refs.form.validate()) {
        this.overlay = true;
        const resposta = await enviarChamadoManutencaoAsync(
          this.descricao,
          this.unidadeAdmSelected.id,
          this.equipamentoSelected.id,
          this.tipo
        );

        if (resposta?.status && resposta.status != 200)  {
          this.overlay = false;
          this.$alert(resposta.message, "Descupe, falha na operação!", "error");
        } else {
          this.overlay = false;
          this.$store.dispatch("ui/showSnackbar", {
            text: "Salvo com sucesso!",
            color: "success",
            timeout: 3000,
          });
          this.$router.push("/chamadoManutencao");
        }
      }
    },
  },
};
</script>
